import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersDataService } from '../../services/users-data.service';
import { AuthService } from '../../services/auth.service';
import { ScreenSizeService } from '../../services/screen-size.service';
import { User } from '../../common.interface';
import {Roles, tutorialsUrl} from '../../common.constants';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss'],
})
export class MainNavComponent implements OnInit {
  user: User;
  authenticated: boolean;
  clinicHomeUrl: string;
  clinicName: string;
  navVisibility = false;
  mainWidth = '300px';
  navList = [
    {
      title: 'Patient List',
      iconName: 'list-i',
      href: '/dashboard/patients',
    },
    {
      title: 'Settings',
      iconName: 'settings-i',
      href: '/dashboard/settings',
    },
  ];

  legalTermsLink: string;
  showChat = false;
  contactEmail = environment.infoEmail;

  constructor(
    private router: Router,
    private usersDataService: UsersDataService,
    private authService: AuthService,
    private sizeService: ScreenSizeService,
    private toastr: ToastrService,
  ) {
  }

  ngOnInit(): void {
    this.mainWidth = this.sizeService.appWidthPx;
    const clinic = this.usersDataService.getLoggedClinicPublicData;
    if (clinic) {
      this.contactEmail = clinic.email;
      this.clinicHomeUrl = clinic.website_url;
      this.clinicName = clinic.name;
      this.showChat = clinic.chat_enabled;
    }
    this.legalTermsLink = this.usersDataService.clinicLegalTermsLink;
    this.user = this.authService.user$.getValue(); // can be null for not authorised pages
    this.authenticated = !!this.user;
  }

  toggleNav() {
    this.navVisibility = !this.navVisibility;
  }

  logout() {
    this.authService.logout();
  }

  newPatient() {
    if (this.user && this.user.role === Roles.SUPERADMIN && !this.usersDataService.getLoggedClinicData.id) {
      this.toastr.warning('Choose clinic from the list');
      this.router.navigate(['dashboard/clinics']);
      this.toggleNav();
      return;
    }
    this.router.navigate(['/dashboard/newPatient']);
  }

  openTutorials() {
    this.toggleNav();
    window.open(tutorialsUrl, '_blank').focus();
  }

  mailTo(e) {
    this.toggleNav();
    e.stopPropagation();
    e.preventDefault();
    window.location.href = 'mailto:' + this.contactEmail;
  }
}
